module.exports = __webpack_public_path__ + "static/images/systemSizeDCIcon.e209287b.svg";